import Index1 from "./pages/Index1/Index1";

const routes = [
  { path: "/", component: Index1 },
];

export default routes;
